import { Container } from "reactstrap"
import Overview from "./Overview/Overview"
import PerformanceOverTime from "./PerformanceOverTime/PerformanceOverTime"
import DistributionChart from "./DistributionChart/DistributionChart"
import Performance from "./Performance/Performance"

const AdPerformance = () => {
  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Ad Performance</h4>

        <div className="px-2">
          
          <Overview />

          <PerformanceOverTime />

          <DistributionChart />

          <Performance />

        </div>

        
      </Container>
    </div>
  )
}

export default AdPerformance
